module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_3.70faf82d.png";